import { useContext } from "react";
import { UserProfileContext, type UserProfileState } from "./UserProfileProvider.tsx";

export function useUserProfile(): UserProfileState {
  const ctx = useContext(UserProfileContext);
  if (!ctx) {
    throw new Error("useUserProfile must be used inside <UserProfileProvider>");
  }
  return ctx;
}
